<template>
  <div v-if="showButton" class="scrollToTop" @click="scrollToTop">
    <dotcom-icon
      class="scrollToTop__icon"
      name="chevron-down"
      art="solid"
      color="--c-secondary-neutral-2"
      hover-color="--c-secondary-neutral-2"
      rotation="180"
    />
  </div>
</template>

<script>
export default {
  name: 'ScrollToTopModule',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  data: () => ({
    scrollTop: 0,
  }),
  computed: {
    showButton() {
      return !this.$mq['md!'] && this.scrollTop > this.windowHeight
    },
    windowHeight() {
      return (
        window.innerHeight ||
        (document.documentElement || document.body).clientHeight
      )
    },
  },

  created() {
    window.addEventListener(
      'scroll',
      () => {
        this.scrollTop =
          window.pageYOffset ||
          (
            document.documentElement ||
            document.body.parentNode ||
            document.body
          ).scrollTop
      },
      false,
    )
  },

  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.scrollToTop {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 20px;
  bottom: 16px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0 8px 14px -7px rgba(0, 0, 0, 0.5);
  z-index: calc(var(--z-index-10) - 2);
  transition: background-color 0.25s ease-in-out;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;

  &:hover {
    background-color: white;
  }
}
</style>
